import React from 'react';

import { WatchedAsset } from '@kaltura-ott/tvpil-shared';

import { CardSkeleton } from 'components/widgets/CardView/CardSkeleton/CardSkeleton';
import { RailCardContainerProps } from 'components/widgets/Rail/components/RailProvider/types';

import ContinueWatchingCard from '../ContinueWatchingCard/ContinueWatchingCard';

function ContinueWatchingCardContainer({ item, itemWidth, imageHeight }: RailCardContainerProps<WatchedAsset>) {
  if (!item?.id) {
    return <CardSkeleton height={imageHeight} width={itemWidth} />;
  }
  return <ContinueWatchingCard imageHeight={imageHeight} itemWidth={itemWidth} item={item} />;
}

export default React.memo(ContinueWatchingCardContainer);
